import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {DataserviceService} from '../../dataservice.service';
import Swal from 'sweetalert2';
import { HttpErrorResponse } from '@angular/common/http';
import * as $ from 'jquery';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';

// import 'bootstrap/dist/js/bootstrap.js';






@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  model: any= {};
  closeResult: string;
  changePasswordError:String;
  currentUrl:String;

  constructor(private router: Router,private dataservice:DataserviceService,private modalService: NgbModal) { }

  ngOnInit() {
    this.currentUrl =  this.router.url;
    console.log(this.currentUrl);
  }

  openModal(id) {
    this.modalService.open(id);

  }




  changePassword2(){
    console.log("1");
    
    this.changePasswordError = "";
    $('div#err.red-text.center.error-message .error-message1').fadeIn();
    $('div#err.red-text.center.error-message .error-message1').fadeOut(10000);
    this.dataservice.changePassword1(this.model).subscribe(
      data =>{
        console.log(data);
        this.modalService.dismissAll();
        this.model.old_password="";
        this.model.new_password="";

        
      },
      (err : HttpErrorResponse)=>{
        console.log(err.error.error_description);

        this.changePasswordError = err.error.error_description;
        
      //  $('#modal-container-688').modal('hide');
      }
    )
    console.log(this.model);
    

  }






  logout(){
    this.dataservice.logout1().subscribe(
      data =>{
        localStorage.clear();
        this.router.navigate(['']);
        console.log(data);
        
      },
      (err : HttpErrorResponse)=>{
        console.log(err.error.error_description);

       Swal(err.error.error_description);
        
      //  $('#modal-container-688').modal('hide');
      }
    )
  }

}
